import React, { useMemo } from 'react';

const ShieldWarningIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-yellow-400 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
    </svg>
);

interface InactivityModalProps {
    countdown: number;
    onStay: () => void;
    onLogout: () => void;
}

const InactivityModal: React.FC<InactivityModalProps> = ({ countdown, onStay, onLogout }) => {
    
    const formattedTime = useMemo(() => {
        const minutes = Math.floor(countdown / 60);
        const seconds = countdown % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }, [countdown]);

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-50 modal-enter" role="dialog" aria-modal="true">
            <div className="bg-gradient-to-br from-[#1a2a47] to-[#15243E] rounded-2xl border border-blue-900/50 w-full max-w-lg text-gray-300 p-8 shadow-2xl relative text-center">
                <div className="flex justify-center mb-4">
                    <ShieldWarningIcon />
                </div>
                <h2 className="text-3xl font-bold text-white">Are you still there?</h2>
                <p className="text-gray-400 mt-4 text-lg">
                    For your security, you will be logged out in...
                </p>
                <div className="my-6 text-7xl font-mono font-bold text-yellow-400 tracking-wider">
                    {formattedTime}
                </div>
                <div className="space-y-4">
                    <button 
                        onClick={onStay}
                        className="w-full bg-gradient-to-br from-yellow-400 to-yellow-500 text-gray-900 font-bold py-3 rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/20 hover:scale-[1.02]"
                    >
                        Stay Logged In
                    </button>
                    <button
                        onClick={onLogout}
                        className="w-full text-center text-gray-400 hover:text-white text-sm mt-4 transition-colors font-semibold"
                    >
                        Log Out Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InactivityModal;